import { Typography } from '@mui/material';

import { Spacer } from 'theSource/components/Spacer';
import { BeneficiaryContainer } from '../BeneficiaryContainer';
import { Beneficiary } from 'theSource/components';
import {
  NoBeneficiariesLabelStyled,
  SwiperSlideStyled,
} from './BeneficiarySlideStyled';

export interface BeneficiarySlideProps {
  title: string;
  beneficiaries?: Beneficiary[];
  fallbackMessage: string;
  itemTestId: string;
}

export const BeneficiarySlide = ({
  title,
  beneficiaries = [],
  fallbackMessage,
  itemTestId = 'beneficiary',
}: BeneficiarySlideProps) => (
  <SwiperSlideStyled>
    <Typography variant="body2Heading">{title}</Typography>
    {beneficiaries.length > 0 ? (
      <>
        {beneficiaries.map((person) => (
          <BeneficiaryContainer
            key={person.id}
            relationship={person.relationship}
            name={person.name}
            allocation={person.allocation}
            testId={itemTestId}
          />
        ))}
      </>
    ) : (
      <>
        <Spacer height={2} />
        <NoBeneficiariesLabelStyled variant="label">
          {fallbackMessage}
        </NoBeneficiariesLabelStyled>
      </>
    )}
  </SwiperSlideStyled>
);

BeneficiarySlide.displayName = 'SwiperSlide'; // Required when SwiperSlide is in a wrapper.
